
export default function VerificationSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Verified Listings',
      description: 'All businesses undergo thorough due diligence and financial verification'
    },
    {
      icon: 'ri-lock-line',
      title: 'Confidential Process',
      description: 'Secure in-portal messaging and NDA protection for all parties'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Qualified Access',
      description: 'Members-only environment ensures serious buyers and sellers'
    }
  ];

  return (
    <section className="py-32 relative">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-light tracking-tight mb-6">
            Verification & <span className="bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent font-medium">Confidentiality</span>
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed">
            All listings and communications are private and governed by standard non-disclosure terms. 
            We protect both buyers and sellers through secure in-portal messaging and verified access only.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center group">
              <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 group-hover:scale-105 cursor-pointer">
                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-green-500/20 to-emerald-500/20 rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${feature.icon} text-2xl text-green-400`}></i>
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold mb-4 text-white">{feature.title}</h3>

                {/* Description */}
                <p className="text-gray-400 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-8 bg-white/5 backdrop-blur-xl border border-white/10 rounded-full px-8 py-4">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-green-400"></i>
              <span className="text-sm text-gray-300">SSL Encrypted</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-lock-line text-blue-400"></i>
              <span className="text-sm text-gray-300">NDA Protected</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-user-star-line text-purple-400"></i>
              <span className="text-sm text-gray-300">Verified Members</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
